import styled from "styled-components";

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing :border-box;
  position : relative;
  @media screen and (max-width : 440px){
    padding-top : 20px;
  }
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
`;

export const Input = styled.input`
  border: 0;
  border-radius: 3px;
  width: 245px;
  height: 35px;
  padding: 5px 0;
  text-align: start;
  padding-left: 10px;
  padding-right: 27px;
  font-size: 16px;
  border :  2px solid  #8bc541;
  border-right : 0;
  border-top-left-radius : 7px;
  border-bottom-left-radius : 7px;
  box-sizing:border-box;
`;

export const SearchButton = styled.button`
  border: 0px;
  /* margin-left: -36px; */
  width: 40px;
  height: 35px;
  background-color: #ffffff;
  background : #8bc541;
  position: relative;
  left: -1px;
  border : 2px solid #8bc541;
  border-radius :  0 7px 7px 0;
  cursor: pointer;
  box-sizing :border-box;
`;
export const ButtonIcon = styled.img`
  width: 18px;
  height: 18px;
`;
